import styled from 'styled-components'

import Picture from '../Picture'
import { mq, sizes } from '../../../theme'
import Html from '../Html'

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 0 1.5rem;
  gap: 1.5rem;
  width: 100%;
  @media ${mq(sizes.tablet)} {
    flex-direction: row;
    gap: 2rem;
  }
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
`

export const Index = styled.div`
  min-width: 8rem;
  min-height: 5rem;
  padding: 0.2rem;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  border-radius: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  ${({ theme }) => theme.textStyles.titleH4};
  color: ${({ theme }) => theme.colors.ruby};
  @media print {
    ${({ theme }) => theme.textStyles.textXSmallStrong};
  }
`

export const Text = styled(Html)<{ $isImportant?: boolean }>`
  color: ${({ theme }) => theme.colors.arapawa};
  ${({ theme }) => theme.textStyles.textLarge}

  @media print {
    ${({ theme }) => theme.textStyles.textSmall};
  }
`

export const Image = styled(Picture)`
  display: flex;
  align-items: center;
  width: 100%;
  flex-shrink: 0;
  @media ${mq(sizes.tablet)} {
    width: 45%;
  }
`
